import styled from 'styled-components';

export const Text = styled.p`
  margin: 20px 10px 0 10px;
  letter-spacing: 0.05em;
  font-weight: 300;
`;
